import React, { useState } from "react";
import LiveAuctionCarDetail from "../components/LiveAuction/LiveAuctionCarDetaill";
import LiveAuctionCarsList from "../components/LiveAuction/LiveAuctionCarsList";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../../utils/constants/routes";
import BuyNowCarsList from "../components/BuyNow/BuyNowCarsList";
import { useBuyNowSocketEvents } from "../components/BuyNow/customHooks/useBuyNowAuctionSocketEvents";
import BuyNowCarDetail from "../components/BuyNow/BuyNowCarDetail";
import BuyNowCarDetailReadOnly from "@common/pages/Dashboard/components/BuyNow/BuyNowCarDetailReadOnly";

const BuyNow = () => {

  // useNavigate...
  const navigate = useNavigate();
  // useNavigate...

  // useLocation...
  const location = useLocation();
  // useLocation...

  // useState variables start...
  const [detailView, setDetailView] = useState(false);
  const [selectedCar, setSelectedCar] = React.useState(null);
  // const [myCarsOrOtherCars, setMyCarsOrOtherCars] = React.useState(null);
  // useState variables end...

  const Vehicle_Id = location?.pathname?.split?.(`${routes.buyNow}/`)?.[1];

  // React.useEffect(() => {
  //   if (myCarsOrOtherCars === null) {
  //     navigate(`${routes.dashboardNavigation}${routes.buyNow}`);
  //   }
  // }, [myCarsOrOtherCars]);

  console.log(Vehicle_Id, "LiveAuction")

  if (Vehicle_Id) {
    return <BuyNowCarDetailReadOnly 
      useBuyNowSocketEvents={useBuyNowSocketEvents}
      selectedCar={selectedCar}
      setSelectedCar={setSelectedCar}
    />;
  }

  return <BuyNowCarsList 
    selectedCar={selectedCar}
    setSelectedCar={setSelectedCar}
    onCarClick={(car) => {
      setSelectedCar(car);
      setDetailView(true);
      navigate(`${routes.dashboardNavigation}${routes.buyNow}/${car?.Vehicle_Id}`);
    }}
  />;
};

export default BuyNow;
